import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5c7fbcb2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  class: "dialog-footer"
};
import { useVModel } from '@vueuse/core';
import { ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { options, formSchemas } from '../config';
// import { getModuleConfig } from '@/api/authModule'
import SelectSearch from '@/components/SelectSearch';
import { getTenantAndClinicPage } from '@/api/tenant';
import { insertDongleUser, updateDongleUser } from '@/api/dongle';
export default {
  __name: 'DongleUser',
  props: {
    // 是否回显数据
    model: {
      type: Object,
      default: null
    },
    modelValue: {
      type: Boolean,
      required: true
    }
  },
  emits: ['update:modelValue', 'refreshData', 'clearModel'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const originFormData = {};

    // 表单数据
    const formData = ref(originFormData);
    const resetForm = () => {
      formData.value = originFormData;
    };
    const cascaderProps = ref({
      value: 'id',
      label: 'name',
      children: 'clinics'
    });
    const tenantData = ref([]);
    const _getAllTenantData = async () => {
      const res = await getTenantAndClinicPage({
        pageSize: 200,
        isParent: 1
      });
      tenantData.value = res.records;
    };
    _getAllTenantData();

    // const moduleConfigArr = ref([])
    // const _getModuleConfig = async () => {
    //   const res = await getModuleConfig({
    //     pageSize: 100
    //   })
    //   moduleConfigArr.value = res.records
    // }

    // _getModuleConfig()

    watch(() => props.model, async val => {
      if (val) {
        formData.value = {
          ...val,
          clinic: [parseInt(val.tenantId), parseInt(val.clinicId)]
        };
      } else {
        resetForm();
      }
    }, {
      immediate: true,
      deep: true
    });
    const emits = __emit;
    const isVisible = useVModel(props);

    // 表单元素
    const formEl = ref(null);
    const handleSelectChange = val => {
      formData.value.tenantName = val;
    };

    /**
     * 新增
     */
    const loading = ref(false);
    const handleAddNewData = async () => {
      if (!formEl.value) return;
      await formEl.value.validate(async (valid, fields) => {
        if (valid) {
          loading.value = true;
          // let igentModuleList = []
          // const beginTime = dayjs(formData.value.authTime[0]).format('YYYY-MM-DD')
          // const endTime = dayjs(formData.value.authTime[1]).format('YYYY-MM-DD')
          // const type = formData.value.type

          // 版本号
          try {
            var _tenant$clinics$find;
            // TODO 增加诊所保存
            const tenantId = formData.value.clinic[0];
            const clinicId = formData.value.clinic[1];
            // const moduleConfigId = formData.value.moduleConfig
            // eslint-disable-next-line
            const tenant = tenantData.value.find(item => item.id == tenantId);
            const tenantName = tenant.name;
            // eslint-disable-next-line
            const clinicName = (_tenant$clinics$find = tenant.clinics.find(item => item.id == clinicId)) === null || _tenant$clinics$find === void 0 ? void 0 : _tenant$clinics$find.name;
            // eslint-disable-next-line
            // const moduleConfigName = moduleConfigArr.value.find((item) => item.id == moduleConfigId).name
            // const menuArrRes = await findAllModuleMenuByConfigId({ id: moduleConfigId })
            // igentModuleList = menuArrRes.map((item) => ({
            //   moduleConfigId,
            //   type,
            //   beginTime,
            //   endTime,
            //   menuId: item.menuId
            // }))
            if (!clinicId) {
              return ElMessage({
                type: 'error',
                message: '请选择诊所!'
              });
            }
            if (!props.model) {
              await insertDongleUser({
                ...formData.value,
                tenantId,
                clinicId: clinicId || '',
                tenantName,
                clinicName: clinicName || ''
              });
            } else {
              await updateDongleUser({
                ...formData.value,
                tenantId,
                clinicId: clinicId || '',
                tenantName,
                clinicName: clinicName || ''
              });
            }
            emits('refreshData');
            ElMessage({
              type: 'success',
              message: props.model ? '修改成功' : '添加成功'
            });
            isVisible.value = false;
          } catch (error) {
            console.log('🚀 ~ file: DongleUser.vue:275 ~ awaitformEl.value.validate ~ error:', error);
          } finally {
            loading.value = false;
          }
        } else {
          ElMessage({
            type: 'error',
            message: '验证失败'
          });
        }
      });
    };
    const closed = () => {
      formEl.value.resetFields();
      resetForm();
      emits('clearModel');
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_input_number = _resolveComponent("el-input-number");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_cascader = _resolveComponent("el-cascader");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        modelValue: _unref(isVisible),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(isVisible) ? isVisible.value = $event : null),
        title: __props.model ? '修改加密狗用户' : '新增加密狗用户',
        onClosed: closed,
        "destroy-on-close": "",
        class: "dialog-class",
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = $event => isVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleAddNewData,
          loading: loading.value
        }, {
          default: _withCtx(() => [_createTextVNode(" 确认 ")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          "label-width": "150px",
          model: formData.value,
          ref_key: "formEl",
          ref: formEl
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formSchemas), (item, index) => {
            return _openBlock(), _createElementBlock(_Fragment, {
              key: index
            }, [item.component === 'Input' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: item.label,
              prop: item.field,
              rules: item.rules
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: formData.value[item.field],
                "onUpdate:modelValue": $event => formData.value[item.field] = $event,
                placeholder: item.placeholder,
                maxlength: item.minlength || '',
                "show-word-limit": item.shoWordLimit,
                disabled: item.disabled || item.field === 'name' && __props.model,
                type: item.type || 'text'
              }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "maxlength", "show-word-limit", "disabled", "type"])]),
              _: 2
            }, 1032, ["label", "prop", "rules"])) : _createCommentVNode("", true), item.component === 'InputTextArea' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 1,
              label: item.label,
              prop: item.field,
              rules: item.rules
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: formData.value[item.field],
                "onUpdate:modelValue": $event => formData.value[item.field] = $event,
                placeholder: item.placeholder,
                type: "textarea",
                autosize: {
                  minRows: 3
                },
                disabled: item.disabled
              }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "disabled"])]),
              _: 2
            }, 1032, ["label", "prop", "rules"])) : _createCommentVNode("", true), item.component === 'InputNumber' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 2,
              label: item.label,
              prop: item.field,
              rules: item.rules
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input_number, {
                modelValue: formData.value[item.field],
                "onUpdate:modelValue": $event => formData.value[item.field] = $event,
                min: 1,
                disabled: item.disabled
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]),
              _: 2
            }, 1032, ["label", "prop", "rules"])) : _createCommentVNode("", true), item.component === 'DateInterval' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 3,
              label: item.label,
              prop: item.field,
              rules: item.rules
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                "unlink-panels": "",
                modelValue: formData.value[item.field],
                "onUpdate:modelValue": $event => formData.value[item.field] = $event,
                type: "daterange",
                "range-separator": "至",
                "start-placeholder": "开始时间",
                "end-placeholder": "结束时间",
                size: "default",
                disabled: item.disabled
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]),
              _: 2
            }, 1032, ["label", "prop", "rules"])) : _createCommentVNode("", true), item.component === 'Radio' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 4,
              label: item.label,
              prop: item.field,
              rules: item.rules
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio_group, {
                modelValue: formData.value[item.field],
                "onUpdate:modelValue": $event => formData.value[item.field] = $event,
                disabled: item.disabled,
                style: {
                  "margin-bottom": "-10px"
                }
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.radioArr, (item, index) => {
                  return _openBlock(), _createBlock(_component_el_radio, {
                    key: index,
                    label: item.value,
                    border: "",
                    style: {
                      "margin-bottom": "10px"
                    }
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
                    _: 2
                  }, 1032, ["label"]);
                }), 128))]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"])]),
              _: 2
            }, 1032, ["label", "prop", "rules"])) : _createCommentVNode("", true), item.component === 'Select' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 5,
              label: item.label,
              prop: item.field
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: formData.value[item.field],
                "onUpdate:modelValue": $event => formData.value[item.field] = $event,
                placeholder: item.placeholder,
                style: {
                  "width": "100%"
                },
                disabled: item.disabled
              }, {
                default: _withCtx(() => [_createElementVNode("template", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(options), item => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]);
                }), 128))])]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder", "disabled"])]),
              _: 2
            }, 1032, ["label", "prop"])) : _createCommentVNode("", true), item.component === 'SelectSearch' && __props.model ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 6,
              label: item.label,
              prop: item.field
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: __props.model.name,
                disabled: "",
                placeholder: "请输入关键字",
                style: {
                  "width": "400px",
                  "margin-bottom": "1rpx"
                }
              }, null, 8, ["modelValue"])]),
              _: 2
            }, 1032, ["label", "prop"])) : _createCommentVNode("", true), item.component === 'SelectSearch' && !__props.model ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 7,
              label: item.label,
              prop: item.field
            }, {
              default: _withCtx(() => [_createVNode(_unref(SelectSearch), {
                modelValue: formData.value[item.field],
                "onUpdate:modelValue": $event => formData.value[item.field] = $event,
                onSelectChange: handleSelectChange
              }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
              _: 2
            }, 1032, ["label", "prop"])) : _createCommentVNode("", true), item.component === 'Cascader' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 8,
              label: item.label,
              prop: item.field,
              rules: item.rules
            }, {
              default: _withCtx(() => [_createVNode(_component_el_cascader, {
                modelValue: formData.value[item.field],
                "onUpdate:modelValue": $event => formData.value[item.field] = $event,
                options: tenantData.value,
                clearable: "",
                props: cascaderProps.value,
                "show-all-levels": false,
                filterable: "",
                style: {
                  "width": "40%"
                },
                disabled: item.disabled
              }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "props", "disabled"])]),
              _: 2
            }, 1032, ["label", "prop", "rules"])) : _createCommentVNode("", true)], 64);
          }), 128))]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue", "title"])]);
    };
  }
};